import { newCampaignStateAtom } from "@/services/new-campaign.service";
import type { Configuration } from "@/types/campaign";
import { store } from "@/utils/jotai";
import { createFileRoute, notFound, Outlet } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import type { SetStateAction } from "jotai";
import { useCallback, useMemo } from "react";
import z from "zod";

export const Route = createFileRoute(
  "/_dashboard/campaigns/setup/define/advanced/$quality",
)({
  component: Outlet,
  params: zodValidator(z.object({ quality: z.coerce.number() })),
  beforeLoad: ({ params: { quality }, context }) => {
    const getConfig = (configurations: Configuration[]) => {
      return configurations.find((c) => c.quality === quality);
    };
    const configuration = getConfig(
      store.get(newCampaignStateAtom).configurations,
    );

    if (!configuration) {
      throw notFound();
    }

    return {
      configuration,
      useAdvancedConfiguration: () => {
        const { newConfigurations, setNewConfigurations } =
          context.useAdvancedConfigurations();
        const configuration = useMemo(
          () => getConfig(newConfigurations),
          [newConfigurations],
        );

        if (!configuration) throw new Error("Configuration not found");

        const setConfiguration = useCallback(
          (update: SetStateAction<Configuration>) => {
            setNewConfigurations((prev) => {
              const configurations = prev.map((c) =>
                c.quality === quality
                  ? typeof update === "function"
                    ? update(c)
                    : update
                  : c,
              );
              return configurations;
            });
          },
          // eslint-disable-next-line react-hooks/exhaustive-deps
          [setNewConfigurations, quality],
        );
        return [configuration, setConfiguration] as const;
      },
    };
  },
});
